define('appkit/model/sort',[
  'datakit/model' 
], function(Model) {

  var SORT_FIELD = 'sort';
  var SORT_DIRECTION = 'sort.dir';

  var SORT_DIRECTIONS = { ascending: 'asc', descending: 'desc' };

  var Paginate = Model.extend({

    toJSON: function() {
      var data = {};

      if (this.has(Paginate.SORT_FIELD)) {
        data[SORT_FIELD] = this.get(SORT_FIELD);
      }

      if (this.has(Paginate.SORT_DIRECTION) && SORT_DIRECTIONS[this.get(Paginate.SORT_DIRECTION)]) {
        data[SORT_DIRECTION] = SORT_DIRECTIONS[this.get(Paginate.SORT_DIRECTION)];
      }

      return data;
    }

  },
  {
    SORT_FIELD     : 'sort',
    SORT_DIRECTION : 'sortDirection',
    ASCENDING      : 'ascending',
    DESCENDING     : 'descending'
  });

  return Paginate;
});
